import Container from '@ui/container/container';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import ProjectSeriesSelect from './project-series-select/project-series-select';
import { GENERAL_EDITABLE_PERMISSIONS } from '@/types/permissions.types';
import useHasPermission from '@/utils/authentication/use-has-permission';

import styles from './edit-project-series.module.css';

const EditProjectSeries = () => {
  const { hasPermission: hasPermissions } = useHasPermission({
    allowedRoles: GENERAL_EDITABLE_PERMISSIONS,
  });

  const defaultProjectSeries: TReactSelectOption[] = [];

  return (
    <Container className={`z-1 ${styles.wrapper}`}>
      <ProjectSeriesSelect defaultSeries={defaultProjectSeries} disabled={!hasPermissions} />
    </Container>
  );
};

export default EditProjectSeries;
